export const flyingObjectDefaults = {
	'speed': '90',
	'rotation': '66',
	'scale': '18.4vmax',
	'flight-path': '387',
	'delay': '2',
}